export const worksGreatTips = (nodeTypeName: string) => {
  switch (nodeTypeName) {
    case 'nbiot_leak':
      return ['Near appliances, plumbing, or sump pumps', 'Near HVAC, boilers, or water heaters', 'In mechanical rooms, basements, kitchens, or bathrooms']
    default:
      return []
  }
}

export const notHereTips = (nodeTypeName: string) => {
  switch (nodeTypeName) {
    case 'nbiot_leak':
      return [
        'Spaces without climate control',
        'Inside or far underneath appliances (refrigerators or washers)',
        'Too far under appliances — signal may fail',
        'High-traffic or splash-prone locations',
      ]
    default:
      return []
  }
}

export const leak5sPlacementTips: Array<{ bold: string; text?: string }> = [
  { bold: 'Next to water heater' },
  { bold: 'Laundry room:', text: ' Near washing machine (especially if on 2nd floor)' },
  { bold: 'Bathroom:', text: ' Under sink, behind toilet' },
  { bold: 'Kitchen:', text: ' Near dishwasher or refrigerator' },
  { bold: 'Utility Room:', text: ' Near furnace or AC system' },
  { bold: 'Basement:', text: ' Near sump pump or where groundwater seepage can occur' },
]

export const leak5sCommercialLinePlacementTips: Array<{ bold: string; text?: string }> = [
  {
    bold: 'Mechanical / Utility Room',
    text: ' Near heating and cooling equipment (boiler, chiller, furnace, air handler, AC system), water heater, or exposed piping',
  },
  { bold: 'Laundry room:', text: ' Near washing machine' },
  { bold: 'Bathroom or Janitor Closet:', text: ' Under sink, behind toilet, near tub' },
  { bold: 'Kitchen or Break Room:', text: ' Near dishwasher, refrigerator, or ice maker' },
  { bold: 'Basement:', text: ' Near sump pump or areas prone to seepage' },
  { bold: 'Rooms with Critical Assets:', text: ' Near electronics and IT, artwork, or important records' },
  { bold: 'Exterior Walls or Spaces:', text: ' Near pipes at risk of freezing' },
]
